<template>
  <div v-if="loading" ref="refHeight" class="loading-container">
    <div class="d-flex justify-content-center mt-5">
      <div class="spinner-border" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">{{ content?.catalogueTraduction?.globalChargement || $t('global.chargement') }}</span>
      </div>
    </div>
  </div>
  <div v-else-if="hasError" ref="refHeight" class="error-container">
    <div class="m-5 alert alert-danger" role="alert">
      <h4 class="alert-heading">{{ content?.catalogueTraduction?.errorTitre || $t('error.titre') }}</h4>
      <p>{{ content?.catalogueTraduction?.errorMessage || $t('error.message') }}</p>
    </div>
  </div>
  <div v-else ref="refHeight">
    <div v-if="content.couvertures?.length > 0" id="activiteCouverture" class="card">
      <img :alt="content.couvertures[0].media.alt" :src="widgetURL + content.couvertures[0].media.url"
           class="card-img-top"
           style="max-height: 350px;"/>
      <div class="card-img-overlay">
        <h1 class="card-title titre text-center">
          <span class="type">{{ content.typeActivite }}</span>
          <br/>
          {{ content.libelle }}
          <span v-if="modePreview" class="text-danger fw-bolder">MODE PRÉVISUALISATION NE PAS PARTAGER CETTE URL</span>
        </h1>
        <router-link :to="{ name: 'Catalogue', query: { catalogue : catalogue }}" class="btn btn-lg btn-warning mt-3">
          <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
            <path clip-rule="evenodd" d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z"
                  fill="white" fill-rule="evenodd"/>
          </svg>
          {{ content?.catalogueTraduction?.activityBtnRevenirListe || $t('activity.btnRevenirListe') }}
        </router-link>
        <button :title="content?.catalogueTraduction?.activityPartagerTips || $t('activity.partagerTips')"
                class="btn btn-lg btn-info mt-3 ms-sm-3"
                data-bs-placement="top"
                data-bs-toggle="tooltip"
                @click.prevent="shareActivity"><span class="bi-link me-2"></span>{{ content?.catalogueTraduction?.activityPartager || $t('activity.partager') }}
        </button>
      </div>
    </div>
    <div id="activite" class="m-5 row">
      <div class="col-lg-8">
        <h1 v-if="!content.couvertures || content.couvertures?.length === 0" class="titre mb-3">
          <span class="type">{{ content.typeActivite }}</span>
          <br/>
          {{ content.libelle }}
          <span v-if="modePreview" class="text-danger fw-bolder">MODE PRÉVISUALISATION NE PAS PARTAGER CETTE URL</span>
        </h1>

        <router-link v-if="!content.couvertures || content.couvertures?.length === 0"
                     :to="{ name: 'Catalogue', query: { catalogue : catalogue }}"
                     class="retour btn btn-lg btn-warning mt-3 mb-3">
          <span class="bi-arrow-return-left"></span>&nbsp;{{ content?.catalogueTraduction?.activityBtnRevenirListe || $t('activity.btnRevenirListe') }}
        </router-link>

        <div v-if="content.themes?.length > 0" class="themes mb-3">
          <h5>{{ content?.catalogueTraduction?.activityThemes || $t('activity.themes') }}</h5>
          <ul class="list-group">
            <li v-for="theme in content.themes" :key="theme.intKey" class="list-group-item">{{ theme.rawLabel }}</li>
          </ul>
        </div>

        <div class="contenu">
          <div v-if="content.description" class="description" v-html="content.description"></div>
        </div>

        <ImageSlider :medias="content.illustrations" :type="'galerie'" :catalogueTraduction="content?.catalogueTraduction"/>

        <h5 v-if="content.periodes" class="mt-3">{{ content?.catalogueTraduction?.activityPeriodes || $t('activity.periodes') }}</h5>
        <div v-if="content.periodes" class="periodes row">
          <div v-for="(periode, index) in content.periodes" :key="periode.id" class="col-xl-6 mb-xl-0 mb-3">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ (content?.catalogueTraduction?.activityPeriode || $t('activity.periode')) + ' ' + (index + 1) }}&nbsp;-&nbsp;{{
                    periode.libelle
                  }}&nbsp;{{ '(' + periode.debut + ' ' + (content?.catalogueTraduction?.formPeriodesAu || $t('form.periodes.au')) + ' ' + periode.fin + ')' }}</h5>
                <ul class="prix list-group">
                  <li v-if="periode.specifique" class="list-group-item base">
                    <strong>{{ content?.catalogueTraduction?.activityPrix || $t('activity.prix') }}&nbsp;:&nbsp;</strong>
                    <span class="fw-bold badge badge-lg bg-secondary">{{ formatPrice(periode.specifique) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                        getLibelleForPrice(periode)
                      }}</small></span>
                  </li>
                  <li v-if="content.reductionMC" class="mc list-group-item">
                    <strong>{{ content?.catalogueTraduction?.activityReductionMC || $t('activity.reductionMC') }}&nbsp;<span :title="content?.catalogueTraduction?.activityToolTipReductionMC || $t('activity.toolTipReductionMC')"
                                                                        class="bi-info-circle"
                                                                        data-bs-placement="top"
                                                                        data-bs-toggle="tooltip"></span>&nbsp;:&nbsp;</strong>
                    <span v-if="content.typeTarifMC === constants.inscription.PRIX_PAR_JOUR"
                          class="fw-bold badge bg-success">{{ formatPrice(content.reductionMC, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                        content?.catalogueTraduction?.activityPrixJour || $t('activity.prixJour')
                      }}</small></span>
                    <span
                        v-else-if="content.typeTarifMC === constants.inscription.PRIX_PAR_PERIODE"
                        class="fw-bold badge bg-success">{{ formatPrice(content.reductionMC, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                        content?.catalogueTraduction?.activityPrixSemaine || $t('activity.prixSemaine')
                      }}</small></span>
                    <span v-else class="fw-bold badge bg-success">{{
                        formatPrice(content.reductionMC, true)
                      }}<small>&nbsp;€</small></span>
                  </li>
                  <li v-if="content.reductionBIM" class="bim list-group-item">
                    <strong>{{ content?.catalogueTraduction?.activityReductionBIM || $t('activity.reductionBIM') }}&nbsp;<span :title="content?.catalogueTraduction?.activityToolTipReductionBim || $t('activity.toolTipReductionBIM')"
                                                                         class="bi-info-circle"
                                                                         data-bs-placement="top"
                                                                         data-bs-toggle="tooltip"></span>&nbsp;:&nbsp;</strong>
                    <span v-if="content.typeTarifBIM === constants.inscription.PRIX_PAR_JOUR"
                          class="fw-bold badge bg-success">{{ formatPrice(content.reductionBIM, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                        content?.catalogueTraduction?.activityPrixJour || $t('activity.prixJour')
                      }}</small></span>
                    <span
                        v-else-if="content.typeTarifBIM === constants.inscription.PRIX_PAR_PERIODE"
                        class="fw-bold badge bg-success">{{ formatPrice(content.reductionBIM, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                        content?.catalogueTraduction?.activityPrixSemaine || $t('activity.prixSemaine')
                      }}</small></span>
                    <span v-else class="fw-bold badge bg-success">{{
                        formatPrice(content.reductionBIM, true)
                      }}<small>&nbsp;€</small></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div v-if="content.tags?.length > 0" class="tags mt-4 mb-4 card-features">
          <ul class="list-group">
            <li v-for="tag in content.tags" :key="tag.id" class="list-group-item">
              <img v-if="tag.image" :alt="tag.image.alt" :src="widgetURL + tag.image.url"
                   style="width: 32px;"/>&nbsp;{{ tag.libelle }}
            </li>
          </ul>
        </div>

        <div v-if="content.lieuActivite && content.lieuActivite.description" ref="infosLieu" class="ns-place mt-3">
          <div class="ns-place-left">
            <h5>{{ content?.catalogueTraduction?.activityLienLieu || $t('activity.lienLieu') }}&nbsp;{{ content.lieuActivite.libelle }}</h5>
            <div v-if="content.lieuActivite.description" class="description"
                 v-html="content.lieuActivite.description"></div>
          </div>
          <div v-if="content.lieuActivite.image" class="ns-place-right">
            <div class="ns-place-picture">
              <img :alt="content.lieuActivite.image.alt"
                   :src="widgetURL + content.lieuActivite.image.url"/>
            </div>
          </div>
        </div>
        <div v-if="content.lieuActivite?.geo" class="ns-map"></div>

        <div v-if="content.organisateurActivite" ref="infosOrga" class="ns-organisation mt-3">
          <h5>{{ content?.catalogueTraduction?.activityOrganisateur || $t('activity.organisateur') }}</h5>
          <p class="ns-organisation-details">
            {{ content.organisateurActivite }}
            <template v-if="content.organisateurEmail"><br/><span
                class="ns-organisation-email">{{ content.organisateurEmail }}</span></template>
            <template v-if="content.organisateurTel"><br/><span
                class="ns-organisation-tel">{{ content.organisateurTel }}</span></template>
          </p>
        </div>

        <div v-if="content.modalites && content.modeInscription === constants.inscription.MODE_INSCRIPTION_TEXTE"
             ref="infosModalites"
             class="modalites">
          <h5>{{ content?.catalogueTraduction?.activityModalites || $t('activity.modalites') }}</h5>
          <div class="description" v-html="content.modalites"></div>
        </div>
      </div>
      <div class="colonne col-lg-4">

        <div class="activiteInfos card">
          <div class="card-body">
            <ActivityInfos :activity="content" :infos-lieu="infosLieu" :infos-orga="infosOrga" :catalogueTraduction="activity?.catalogueTraduction"/>
          </div>
        </div>

        <div class="boutons mt-3">
          <p v-if="content.modeInscription === constants.inscription.MODE_INSCRIPTION_AUCUNE || content.inscriptionComplet">
            <button class="btn btn-lg btn-danger" disabled>{{ content?.catalogueTraduction?.activityInscriptionImpossible || $t('activity.inscriptionImpossible') }}</button>
          </p>
          <p v-else-if="content.inscriptionPossible" class="mt-3">

            <a v-if="content.modeInscription === constants.inscription.MODE_INSCRIPTION_EXTERNE"
               :href="content.formulaireExterne" target="_blank" class="btn btn-lg btn-success">{{ content?.catalogueTraduction?.activityBtnInscription || $t('activity.btnInscription') }}</a>

            <a v-else-if="content.modeInscription === constants.inscription.MODE_INSCRIPTION_TEXTE"
               class="btn btn-lg btn-success"
               href="#"
               @click.prevent="goToPageArea(infosModalites)">{{ content?.catalogueTraduction?.activityBtnInscriptionModalites || $t('activity.btnInscriptionModalites') }}</a>

<!--            <router-link v-else-->
<!--                         :to="{ name: 'Form', params: { activityId : content.id, id: content.formulaireInscription, catalogueId : catalogue}}"-->
<!--                         class="btn btn-lg btn-success">-->
<!--              {{ $t('activity.btnInscription') }}-->
<!--            </router-link>-->

            <a v-else href="#" class="btn btn-lg btn-success" @click.prevent="redirectExternal">{{ content?.catalogueTraduction?.activityBtnInscription || $t('activity.btnInscription') }}</a>


          </p>
          <p v-else-if="content.inscriptionListeAttentePossible" class="mt-3">
            <router-link
                :to="{ name: 'Form', params: { activityId : content.id, id: content.formulaireInscription, catalogueId : catalogue}}"
                class="btn btn-lg btn-warning">
              {{ content?.catalogueTraduction?.activityBtnListeAttente || $t('activity.btnListeAttente') }}
            </router-link>
          </p>

          <div v-if="content.optins?.length > 0" class="optins mt-3">
            <div v-for="optin in content.optins" :key="optin.id" class="optin mb-3">
              <p v-if="optin.url"><a :href="optin.url" target="_blank">{{ optin.nom }}</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref} from "vue";
import axios from 'axios';
import ImageSlider from "@/components/ImageSlider";
import constants from "@/constants";
import {useStore} from "vuex";
import ActivityInfos from "@/components/ActivityInfos";
import {formatPrice, goToPageArea, useTooltips} from "@/utils";
import {useRouter} from "vue-router";

export default {
  name: "Activity",
  components: {ActivityInfos, ImageSlider},
  props: ['catalogue', 'activity'],
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const loading = ref(true);
    const content = ref({});
    const hasError = ref(false);
    const widgetURL = process.env.VUE_APP_WIDGET_API_SERVER;
    const infosLieu = ref(null);
    const infosOrga = ref(null);
    const infosConditions = ref(null);
    const infosModalites = ref(null);
    const refHeight = ref(null);
    const modePreview = ref(false);

    onBeforeMount(() => {
      // to clear previous form stored datas in the same session
      sessionStorage.clear()
      addEventListener("resize", handleHeight, {passive: true});
    });

    onBeforeUnmount(() => {
      removeEventListener("resize", handleHeight);
    });

    onMounted(async () => {
      if (props.catalogue > 0 && props.activity > 0) {
        modePreview.value = router.currentRoute?.value?.query?.preview === 'true';
        await axios
            .get(process.env.VUE_APP_WIDGET_API_ROOT + '/activity' + '/' + props.catalogue + '/' + props.activity, {
              params: {preview: modePreview.value}
            })
            .then(response => {
              content.value = response.data;
              if (!content.value.actif)
                hasError.value = true;
              store.commit('updateActivity', content.value);
            })
            .catch(error => {
              console.error(error);
              hasError.value = true;
            })
            .finally(() => {
              loading.value = false;
            });
      } else {
        loading.value = false;
        hasError.value = true;
      }

      await handleHeight();
      await useTooltips();
      refHeight.value?.scrollIntoView({behavior: 'smooth'});
    });

    const handleHeight = async () => {
      await nextTick();
      let height = refHeight.value?.offsetHeight + 50;
      if (hasError.value)
        height += 200;
      window.parent.postMessage({frameHeight: height}, '*');
    };
    const getLibelleForPrice = (periode) => {
      if (periode.nbJours < 4)
        return content?.value.catalogueTraduction?.activityPrixJour || 'jour';
      else if (periode.nbJours >= 4 && periode.nbJours <= 7)
        return content?.value.catalogueTraduction?.activityPrixSemaine || 'semaine';
      else
        return content?.value.catalogueTraduction?.activityPrixQuinzaine || 'quinzaine';
    };

    const shareActivity = () => {
      window.parent.postMessage({shareLink: `?wid_c=${props.catalogue}&wid_a=${props.activity}&wstyle=${localStorage.getItem('style')?.replace('widget-', '')}`}, '*');
    };

    const redirectExternal = () => {
      if (self === top || !content.value.validationAutomatique) {
        // si pas dans le contexte iframe
        router.push({
          name: 'Form',
          params: {activityId: props.activity, id: content.value.formulaireInscription, catalogueId: props.catalogue}
        });
      } else {
        // si intégré via iframe
        const style = localStorage.getItem('style');

        if (style && style.trim()) {
          // Si local storage contient la valeur style, ajoute le paramètre style dans l'url lors de la redirection
          window.parent.postMessage({
            externalNav: `${process.env.VUE_APP_WIDGET_URL}/form/${props.catalogue}/${props.activity}/${content.value.formulaireInscription}?style=${style.replace('widget-', '')}`
          }, '*');
        } else {
          window.parent.postMessage({
            externalNav: `${process.env.VUE_APP_WIDGET_URL}/form/${props.catalogue}/${props.activity}/${content.value.formulaireInscription}`
          }, '*');
        }
      }
    };

    return {
      loading,
      hasError,
      content,
      constants,
      widgetURL,
      infosLieu,
      infosOrga,
      infosConditions,
      infosModalites,
      goToPageArea,
      getLibelleForPrice,
      refHeight,
      formatPrice,
      modePreview,
      shareActivity,
      redirectExternal,
    };
  }
}
</script>

<style scoped>
ul .no-bullets {
  list-style-type: none;
}

div.error-container, div.loading-container {
  padding: 100px;
}

.btn-info {
  background-color: #0dcaf0 !important;
}
.btn-info:hover{
  opacity: 0.8;
}
</style>
